<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
<loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
      <b-row>
        <b-col>
         <br/><br/><br/><br/><br/><br/>
        </b-col>
      </b-row>
      
       <b-row>
        <b-col>
         <h3>Bandeja de Pti </h3>
        </b-col>
      </b-row>
      

      <b-row>
        <b-col>

          <b-table
                id="Pendientes"
                thead-tr-class="columnas"
                :items="datosTablaDiagnostico"
                :fields="encabezadosDiagnostico"  
                responsive
                 
              >
               <template #cell()="data">
                  <div
                    :is="data.field.component"
                    :data="data"
                    v-if="data.field.component !== undefined"                    
                  ></div>
                  <span v-else>{{ data.value }}</span>
                </template>

                <template v-slot:cell(nombreEmbajador)="row">
                    {{ row.value }}
                </template>
                <template v-slot:cell(nombreEstatusEmbajador)="row">
                    {{ row.value }}
                </template>
              </b-table>
              
              
        </b-col>
      </b-row>
            
             <b-row>
        <b-col>
        <br/><br/><br/><br/><br/><br/>
        </b-col>
      </b-row>
      
      
             <b-row>
        <b-col>
         <h3>Bandeja de Especialistas </h3>
        </b-col>
      </b-row>
      

      <b-row>
        <b-col>
          
          <b-table
                id="Pendientes"
                thead-tr-class="columnas"
                :items="datosTablaEspecialista"
                :fields="encabezadosEspecialista"  
                responsive
                 
              >
               <template #cell()="data">
                  <div
                    :is="data.field.component"
                    :data="data"
                    v-if="data.field.component !== undefined"                    
                  ></div>
                  <span v-else>{{ data.value }}</span>
                </template>
                 
              </b-table>
              
              
        </b-col>
      </b-row>
      
      
      
     
              
      <b-row>
        <b-col>
         <br/><br/><br/><br/><br/><br/>
         <br/><br/><br/><br/><br/><br/>
        </b-col>
      </b-row>
  </div>
</template>

<script> 
export default {
  name: "HistorialBandejasPorPacienteComponente",
  components: {
  },
  props: {
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    idPaciente : null,
   loading: false,
   datosTablaDiagnostico : [],
   datosTablaEspecialista : [],
   encabezadosDiagnostico: [

     {
       key: "dtefechaAltaPti",
       label: "Fecha de creación del pti",
       component: "BandejaFechaComponente",
       sortable: true,
     },
     {
        key: "idSolicitud",
        label: "id solicitud",
        sortable: true,
      },      
      {
        key: "nombreTipoSolicitud",
        label: "Tipo de Solicitud",
        sortable: true,
      },
      {
        key: "dtefechaAlta",
        label: "Fecha de creación de la bandeja",
        component: "BandejaFechaTextoComponente",
        sortable: true,
      },
      {
        key: "pacientePresencial",
        label: "paciente en clínica",
        component: "PacientePresencialComponente",        
        sortable: true,
      },
      
      {
        key: "nombreClinica",
        label: "nombre Clínica",
        sortable: true,
      },
      
      {
        key: "nombreSolicitante",
        label: "doctor que solicito ",
        sortable: true,
      },
      
      {
        key: "nombreDiagnosticador",
        label: "nombre Diagnosticador de cdx",
        sortable: true,
      },
      {
        key: "nombreEstatusCdx",
        label: "Estatus bandeja cdx",
        sortable: true,
      },
      {
        key: "nombreEmbajador",
        label: "embajador de clínica",
        sortable: true,
      },       
      {
        key: "nombreEstatusEmbajador",
        label: "estatus bandeja embajador",
        sortable: true,
      },
      {
        key: "idPti",
        label: "id Pti",
        sortable: true,
      },
      
      {
        key: "registroActivoPti",
        label: "Estatus Pti",
        sortable: true,
      },
      {
        key: "registroActivo",
        label: "Registro activo/inactivo de la bandeja",
        sortable: true,
      },
      
      {
        key: "dtehoraSolicitud",
        label: "Hora de solicitud de la bandeja por clínica",
        component: "BandejaFechaComponente",
        sortable: true,
      },
      {
        key: "dtefechaModificacion",
        label: "Fecha de la ultima modificación",
        component: "BandejaFechaComponente",
        sortable: true,
      }
    ],
    
    
    
    
    encabezadosEspecialista: [
     
      {
        key: "idSolicitud",
        label: "id solicitud",
        sortable: true,
      },      
      {
        key: "nombreTipoSolicitud",
        label: "Tipo de Solicitud",
        sortable: true,
      },
       
       {
        key: "dtefechaAlta",
        label: "Fecha de creación de la bandeja",
        component: "BandejaFechaTextoComponente",
        sortable: true,
      },
      // {
      //   key: "idPaciente",
      //   label: "id paciente",
      //   sortable: true,
      // },
      // {
      //   key: "nombrePaciente",
      //   label: "nombre paciente",
      //   sortable: true,
      //   component: "NombrePacienteComponente",
      // },
      {
        key: "idPti",
        label: "id Pti",
        sortable: true,
      },
      {
        key: "registroActivoPti",
        label: "Estatus Pti",
        sortable: true,
      },
      {
        key: "dtefechaAltaPti",
        label: "Fecha de creación del pti",
        component: "BandejaFechaComponente",
        sortable: true,
      },  
      {
        key: "empleadoEspecialista",
        label: "Especialista",
        sortable: true,
      },
      
      {
        key: "nombreEstatusEspecialista",
        label: "Estatus de la bandeja del especialista",
        sortable: true,
      },  
      {
        key: "dtefechaModificacion",
        label: "Fecha de la ultima modificación",
        component: "BandejaFechaComponente",
        sortable: true,
      },
      {
        key: "nombreUsuarioAlta",
        label: "Usuario que crea la solicitud",
        sortable: true,
      },
      {
        key: "nombreUsuarioModificacion",
        label: "Usuario que modifica la solicitud",
        sortable: true,
      }, 
      {
        key: "registroActivo",
        label: "Registro activo/inactivo de la bandeja",
        sortable: true,
      },
      {
        key: "comentarios",
        label: "comentarios",
        sortable: true,
      },
    ],
    
    
    
  }),
  watch: {},
  computed: {},

  created() {
    this.idPaciente = this.$route.params.id;
      this.getObtenerDatosBandejaDiagnostico();
      this.getObtenerDatosBandejaEspecialista();
    this.debug = this.$localStorageService.getDebug();
  },
  mounted() {},
  methods: {
      getObtenerDatosBandejaDiagnostico(){
          this.loading = true;
            this.datosTablaDiagnostico = [];
          const parametros = {idPaciente: this.idPaciente}
           this.$http
        .post(
          this.$api +
            "paciente/obtenerHistorialDeBandejasDiagnostico", parametros
        )
        .then((response) => {
          this.datosTablaDiagnostico = response.data.data;
         
        })
        .catch((error) => {
          console.error(error);
        }).finally(() => {
           this.loading = false;
        }); 
      },
      
      getObtenerDatosBandejaEspecialista(){
          this.loading = true;
            this.datosTablaEspecialista = [];
            const parametros = {idPaciente: this.idPaciente}
           this.$http
        .post(
          this.$api +
            "paciente/obtenerHistorialDeBandejasEspecialista", parametros
        )
        .then((response) => {
          this.datosTablaEspecialista = response.data.data;
         
        })
        .catch((error) => {
          console.error(error);
        }).finally(() => {
           this.loading = false;
        }); 
      },
      
      
      
      
      

  },
};
</script>
 